import React from 'react'
import ProjectChartTop from './projectChartTop/ProjectChartTop'

const ProjectCardTop = () => {
    return (
        <div className='w-full h-fit text-sm font-color-4 flex flex-col'>
            <div className='flex-1 justify-between items-center'>
                <div className=''>Top 10</div>
                <div className='text-sm font-color-6 py-2'>Die zehn besten Projekte</div>
                <div
                    className='overflow-y-auto max-h-chart-scroll scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-gray-200'>
                    <ProjectChartTop/>
                </div>
            </div>
        </div>
    );
};


export default ProjectCardTop